import React, { useState } from "react";
import { Link } from "react-router-dom";

// project-imports
import SectionTitle from "../sectionTitle/SectionTitle";
import PostThree from "../../components/post/PostThree";
import {
    GoogleAnalyticsEnum,
    triggerFunction,
} from "../../utils/google-analytics";
import HomeFourBlogStencil from "./HomeFourBlogStencil";
import PostYouTubeVideo from "../post/PostYouTubeVideo";
import GalleryDrawer from "../our-gallery/GalleryDrawer";

// third-party
import ScrollAnimation from "react-animate-on-scroll";
import FsLightbox from "fslightbox-react";
import VideoContentWidget from "../reusable/widgets/VideoContentWidget";
import { useGalleryContext } from "../../context/gallery_context";
import ReusableWidget from "../reusable/widgets/ReusableWidget";
import ErrorComponent from "../error-message/ErrorComponent";

const HomeFourBlog = ({
    data,
    title,
    subTitle,
    isShowYtVideo,
    videoType,
    stencilLoading,
    classes,
}) => {
    // Extracting variables from context
    const { galleryData, popularVideos, popularShorts, galleryLoading, galleryError } = useGalleryContext();

    // state variable initialization
    const [toggler, setToggler] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const dataCloudSeriesData =
        (galleryData || []).filter(
            (i) => i?.playlistName === "Salesforce Data Cloud Series",
        ) || [];
    const ytLiveSessionsData =
        (galleryData || []).filter((i) => i?.playlistName === "Salesforce Live") ||
        [];

    const handleVideoToggle = (url) => {
        try {
            setVideoUrl(url);
            setToggler(!toggler);
        } catch (error) { }
    };

    const handleOpenDrawer = (data) => {
        try {
            setOpenDrawer(true);
            setSelectedItem(data);
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.SF_TUTORIALS_DETAIL_VIEW,
            );
        } catch (error) {
            console.log(
                "49 : HomeFourBlog : Error in handleOpenDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };

    const handleHideDrawer = () => {
        try {
            setOpenDrawer(false);
        } catch (error) {
            console.log(
                "60 : HomeFourBlog : Error in handleHideDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };

    if (galleryLoading) {
        return <HomeFourBlogStencil data={data} />;
    }

    return (
        <div
            className={`eduvibe-home-four-blog edu-blog-area edu-section-gap ${classes ? classes : "bg-color-grey"}`}
        >
            <div className="container eduvibe-animated-shape">
                <div className="row g-5 y-gap-15 align-items-start justify-content-between">
                    <div className="col-12 col-lg-8">
                        <div className="row g-5 y-gap-15 align-items-start justify-content-between">
                            <div className="col-12 col-lg-6">
                                <div className="row g-5 y-gap-15 align-items-start justify-content-between">
                                    <div className="col-9">
                                        <div className="section-title text-start">
                                            <span className="pre-title fs-10">Beginner to Advanced</span>
                                            <h6 className="title fs-20">Salesforce Data Cloud</h6>
                                        </div>
                                    </div>
                                    <div className="col-3 text-end">
                                        <a
                                            class="fs-14 color-primary text-decoration-underline"
                                            href="/salesforce-tutorials"
                                        >
                                            View All
                                        </a>
                                    </div>
                                </div>

                                {!galleryLoading && galleryError ? (
                                    <div className="row">
                                        <ErrorComponent
                                            errorCode="500"
                                            mainError="No salesforce data cloud data are available!"
                                            subText="Currently we don't have salesforce data cloud data. Please be back later."
                                            buttonText="Back to Home"
                                            link="/"
                                        />
                                    </div>
                                ) : (!galleryLoading && !galleryError && !dataCloudSeriesData?.length) ? (
                                    <div className="row">
                                        <ErrorComponent
                                            errorCode="404"
                                            mainError="Failed to get the salesforce data cloud data right now."
                                            subText="Please return to the site's homepage, It looks like nothing was found at this location"
                                            buttonText="Back to Home"
                                            link="/"
                                        />
                                    </div>

                                ) : (
                                    <>
                                        <div className="row y-gap-15 pt--20">
                                            {(dataCloudSeriesData || [])
                                                .slice(0, 6)
                                                .map((item, index) => (
                                                    <>
                                                        <ScrollAnimation
                                                            animateIn="fadeInUp"
                                                            animateOut="fadeInOut"
                                                            animateOnce={true}
                                                            className="col-lg-12 col-md-12 col-12"
                                                            key={item.id}
                                                        >
                                                            {isShowYtVideo ? (
                                                                // <PostYouTubeVideo data={item} index={index} onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} />
                                                                <VideoContentWidget
                                                                    data={item}
                                                                    onVideoToggle={handleVideoToggle}
                                                                    onOpenDrawer={handleOpenDrawer}
                                                                />
                                                            ) : (
                                                                <PostThree data={item} />
                                                            )}
                                                        </ScrollAnimation>
                                                    </>
                                                ))}
                                        </div>
                                    </>
                                )}

                            </div>

                            <div className="col-12 col-lg-6">
                                <div className="row g-5 y-gap-15 align-items-start justify-content-between">
                                    <div className="col-9">
                                        <div className="section-title text-start">
                                            <span className="pre-title fs-10">Live Sessions On YouTube</span>
                                            <h6 className="title fs-20">Salesforce Live Streams</h6>
                                        </div>
                                    </div>
                                    <div className="col-3 text-end">
                                        <a
                                            class="fs-14 color-primary text-decoration-underline"
                                            href="/salesforce-tutorials"
                                        >
                                            View All
                                        </a>
                                    </div>
                                </div>

                                {!galleryLoading && galleryError ? (
                                    <div className="row">
                                        <ErrorComponent
                                            errorCode="500"
                                            mainError="No salesforce live streams data  data are available!"
                                            subText="Currently we don't have salesforce live streams data  data. Please be back later."
                                            buttonText="Back to Home"
                                            link="/"
                                        />
                                    </div>
                                ) : (!galleryLoading && !galleryError && !ytLiveSessionsData?.length) ? (
                                    <div className="row">
                                        <ErrorComponent
                                            errorCode="404"
                                            mainError="Failed to get the salesforce live streams data right now."
                                            subText="Please return to the site's homepage, It looks like nothing was found at this location"
                                            buttonText="Back to Home"
                                            link="/"
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <div className="row y-gap-15 pt--20">
                                            {(ytLiveSessionsData || []).slice(0, 6).map((item, index) => (
                                                <>
                                                    <ScrollAnimation
                                                        animateIn="fadeInUp"
                                                        animateOut="fadeInOut"
                                                        animateOnce={true}
                                                        className="col-lg-12 col-md-12 col-12"
                                                        key={item.id}
                                                    >
                                                        {isShowYtVideo ? (
                                                            // <PostYouTubeVideo data={item} index={index} onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} />
                                                            <VideoContentWidget
                                                                data={item}
                                                                onVideoToggle={handleVideoToggle}
                                                                onOpenDrawer={handleOpenDrawer}
                                                            />
                                                        ) : (
                                                            <PostThree data={item} />
                                                        )}
                                                    </ScrollAnimation>
                                                </>
                                            ))}
                                        </div>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <ReusableWidget data={popularVideos || []} title="Popular Videos" href="https://www.youtube.com/@LongswitchAcademy/videos" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} />
                        <ReusableWidget data={popularShorts || []} title="Popular Shorts Videos" href="https://www.youtube.com/@LongswitchAcademy/shorts" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} />
                    </div>
                </div>

                {/* <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-32.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-03-08.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-27-01.png" alt="Shape Thumb" />
                    </div>
                </div> */}
            </div>
            <div className="video-lightbox-wrapper">
                <FsLightbox
                    toggler={toggler}
                    sources={[videoUrl]}
                    maxYoutubeVideoDimensions={
                        videoType === "short"
                            ? { width: 1080, height: 1920 }
                            : { width: 1920, height: 1080 }
                    }
                />
            </div>

            {selectedItem && (
                <GalleryDrawer
                    show={openDrawer}
                    classes={null}
                    onClose={handleHideDrawer}
                    data={selectedItem}
                    onVideoToggle={handleVideoToggle}
                    title={"Salesforce Tutorials Info"}
                    isLoading={galleryLoading}
                />
            )}
        </div>
    );
};

export default HomeFourBlog;
